import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactDOMServer from 'react-dom/server';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { DocSearchModal, useDocSearchKeyboardEvents } from '@docsearch/react';
import Chip from '@mui/material/Chip';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import StickyNote2RoundedIcon from '@mui/icons-material/StickyNote2Rounded';
import SmartButtonRoundedIcon from '@mui/icons-material/SmartButtonRounded';
import IntegrationInstructionsRoundedIcon from '@mui/icons-material/IntegrationInstructionsRounded';
import DesignServicesRoundedIcon from '@mui/icons-material/DesignServicesRounded';
import CopyrightRoundedIcon from '@mui/icons-material/CopyrightRounded';
import CollectionsBookmarkRoundedIcon from '@mui/icons-material/CollectionsBookmarkRounded';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded';
import GlobalStyles from '@mui/material/GlobalStyles';
import { alpha } from '@mui/material/styles';
import { pathnameToLanguage } from 'docs/src/modules/utils/helpers';
import { LANGUAGES_SSR } from 'docs/config';
import { Link } from '@mui/docs/Link';
import { useTranslate, useUserLanguage } from '@mui/docs/i18n';
import useLazyCSS from 'docs/src/modules/utils/useLazyCSS';
import PageContext from 'docs/src/modules/components/PageContext';
import SearchButton from './SearchButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NewStartScreen() {
  var startScreenOptions = [{
    category: {
      name: 'Material UI'
    },
    items: [{
      name: 'Installation',
      href: '/material-ui/getting-started/installation/',
      icon: /*#__PURE__*/_jsx(DownloadRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Components',
      href: '/material-ui/getting-started/supported-components/',
      icon: /*#__PURE__*/_jsx(SmartButtonRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Example projects',
      href: '/material-ui/getting-started/example-projects/',
      icon: /*#__PURE__*/_jsx(LibraryBooksRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Templates',
      href: '/material-ui/getting-started/templates/',
      icon: /*#__PURE__*/_jsx(CollectionsBookmarkRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }]
  }, {
    category: {
      name: 'MUI X'
    },
    items: [{
      name: 'Overview',
      href: '/x/introduction/',
      icon: /*#__PURE__*/_jsx(StickyNote2RoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Licensing',
      href: '/x/introduction/licensing/',
      icon: /*#__PURE__*/_jsx(CopyrightRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'What is new in MUI X',
      href: '/x/whats-new/',
      icon: /*#__PURE__*/_jsx(NewspaperRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }]
  }, {
    category: {
      name: 'Joy UI'
    },
    items: [{
      name: 'Installation',
      href: '/joy-ui/getting-started/installation/',
      icon: /*#__PURE__*/_jsx(DownloadRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Templates',
      href: '/joy-ui/getting-started/templates/',
      icon: /*#__PURE__*/_jsx(CollectionsBookmarkRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Customization',
      href: '/joy-ui/customization/approaches/',
      icon: /*#__PURE__*/_jsx(DesignServicesRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }]
  }, {
    category: {
      name: 'Toolpad'
    },
    items: [{
      name: 'Overview',
      href: '/toolpad/studio/getting-started/',
      icon: /*#__PURE__*/_jsx(StickyNote2RoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Why Toolpad?',
      href: '/toolpad/studio/getting-started/why-toolpad/',
      icon: /*#__PURE__*/_jsx(ChecklistRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Example applications',
      href: '/toolpad/studio/examples/',
      icon: /*#__PURE__*/_jsx(LibraryBooksRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }]
  }, {
    category: {
      name: 'MUI System'
    },
    items: [{
      name: 'Overview',
      href: '/system/getting-started/',
      icon: /*#__PURE__*/_jsx(StickyNote2RoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'Usage',
      href: '/system/getting-started/usage/',
      icon: /*#__PURE__*/_jsx(IntegrationInstructionsRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }, {
      name: 'The sx prop',
      href: '/system/getting-started/the-sx-prop/',
      icon: /*#__PURE__*/_jsx(SettingsRoundedIcon, {
        className: "DocSearch-NewStartScreenTitleIcon"
      })
    }]
  }];
  return /*#__PURE__*/_jsx("div", {
    className: "DocSearch-NewStartScreen",
    children: startScreenOptions.map(function (_ref) {
      var category = _ref.category,
        items = _ref.items;
      return /*#__PURE__*/_jsxs("div", {
        className: "DocSearch-NewStartScreenCategory",
        children: [/*#__PURE__*/_jsx("div", {
          className: "DocSearch-NewStartScreenTitle",
          children: category.name
        }), items.map(function (_ref2) {
          var name = _ref2.name,
            icon = _ref2.icon,
            href = _ref2.href;
          return /*#__PURE__*/_jsxs(NextLink, {
            href: href,
            className: "DocSearch-NewStartScreenItem",
            children: [icon, name]
          }, name);
        })]
      }, category.name);
    })
  });
}
var productNameProductId = {
  'material-ui': 'Material UI',
  'joy-ui': 'Joy UI',
  'base-ui': 'MUI Base',
  x: 'MUI X',
  system: 'MUI System',
  toolpad: 'Toolpad',
  'toolpad-studio': 'Toolpad Studio',
  'toolpad-core': 'Toolpad Core',
  'docs-infra': 'Docs Infra'
};
export function convertProductIdToName(productInfo) {
  return productNameProductId[productInfo.productId] || productNameProductId[productInfo.productCategoryId];
}
function getDisplayTag(hit) {
  if (hit.productId === undefined || hit.productCategoryId === undefined) {
    return null;
  }
  var productName = convertProductIdToName({
    productId: hit.productId,
    productCategoryId: hit.productCategoryId
  });
  if (!productName) {
    console.error("getDisplayTag missing mapping for productId: ".concat(hit.productId, ", pathname: ").concat(hit.pathname, "."));
  }
  return /*#__PURE__*/_jsx(Chip, {
    label: productName,
    size: "small",
    variant: "outlined",
    sx: {
      mr: 1
    }
  });
}
function DocSearchHit(props) {
  var children = props.children,
    hit = props.hit;
  if (hit.pathname) {
    return /*#__PURE__*/_jsxs(Link, {
      href: hit.pathname,
      as: hit.as,
      sx: {
        display: 'flex !important',
        '& .DocSearch-Hit-Container': {
          flex: 1,
          minWidth: 0
        }
      },
      children: [children, getDisplayTag(hit)]
    });
  }

  // DocSearch stores the old results in its cache
  // hit.pathname won't be defined for them.
  return /*#__PURE__*/_jsx(Link, {
    href: hit.url,
    children: children
  });
}
false ? void 0 : void 0;
var standaloneProducts = ['base-ui', 'joy-ui'];
export default function AppSearch(props) {
  useLazyCSS('https://cdn.jsdelivr.net/npm/@docsearch/css@3.0.0-alpha.40/dist/style.min.css', '#app-search', {
    layer: 'docsearch'
  });
  var FADE_DURATION = 120; // ms
  var t = useTranslate();
  var userLanguage = useUserLanguage();
  var searchButtonRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  var _React$useState3 = React.useState(undefined),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    initialQuery = _React$useState4[0],
    setInitialQuery = _React$useState4[1];
  var facetFilterLanguage = LANGUAGES_SSR.includes(userLanguage) ? "language:".concat(userLanguage) : "language:en";
  var onOpen = React.useCallback(function () {
    setIsOpen(true);
  }, [setIsOpen]);
  var router = useRouter();
  var pageContext = React.useContext(PageContext);
  var keyboardNavigator = {
    navigate: function navigate(_ref3) {
      var item = _ref3.item;
      var as = item.userLanguage !== 'en' ? "/".concat(item.userLanguage).concat(item.as) : item.as;
      router.push(item.pathname, as);
    }
  };
  var onClose = React.useCallback(function () {
    var modal = document.querySelector('.DocSearch-Container');
    if (modal) {
      // fade out transition
      modal.style.opacity = 0;
    }
    setIsOpen(false); // DO NOT call setIsOpen inside a timeout (it causes scroll issue).
  }, [setIsOpen]);
  var onInput = React.useCallback(function (event) {
    setIsOpen(true);
    setInitialQuery(event.key);
  }, [setIsOpen, setInitialQuery]);
  useDocSearchKeyboardEvents({
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onInput: onInput,
    searchButtonRef: searchButtonRef
  });
  React.useEffect(function () {
    var addStartScreen = function addStartScreen() {
      var dropDown = document.querySelector('.DocSearch-Dropdown');
      var isExisting = document.querySelector('.DocSearch-NewStartScreen');
      if (dropDown && !isExisting) {
        dropDown.insertAdjacentHTML('beforeend', ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/_jsx(NewStartScreen, {})));
      }
    };
    // add transition to Modal
    if (isOpen) {
      var modal = document.querySelector('.DocSearch-Container');
      var searchInput = document.querySelector('.DocSearch-Input');
      if (modal) {
        modal.style.opacity = 1;
        addStartScreen();
      }
      if (searchInput) {
        var handleInput = function handleInput(event) {
          var newStartScreen = document.querySelector('.DocSearch-NewStartScreen');
          if (newStartScreen) {
            newStartScreen.style.display = event.target.value !== '' ? 'none' : 'grid';
          }
        };
        searchInput.addEventListener('input', handleInput);
        return function () {
          searchInput.removeEventListener('input', handleInput);
        };
      }
    }
    return function () {};
  }, [isOpen]);
  var optionalFilters = [];
  if (pageContext.productId !== 'null') {
    optionalFilters.push("productId:".concat(pageContext.productId));
  } else if (pageContext.productCategoryId !== 'null') {
    optionalFilters.push("productCategoryId:".concat(pageContext.productCategoryId));
  }

  // Filter out stand-alone products unless we're on their subsections
  var filters = undefined;
  if (standaloneProducts.length > 0) {
    var filtersPredicates = [];
    for (var i = 0; i < standaloneProducts.length; i += 1) {
      if (pageContext.productId !== standaloneProducts[i]) {
        filtersPredicates.push("NOT productId:".concat(standaloneProducts[i]));
      }
    }
    filters = filtersPredicates.join(' AND ');
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(SearchButton, _extends({
      onRef: searchButtonRef,
      onClick: onOpen
    }, props)), isOpen && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(DocSearchModal, {
      initialQuery: initialQuery,
      appId: "TZGZ85B9TB",
      apiKey: "8177dfb3e2be72b241ffb8c5abafa899",
      indexName: "material-ui",
      searchParameters: {
        facetFilters: ['version:master', facetFilterLanguage],
        filters: filters,
        optionalFilters: optionalFilters,
        attributesToRetrieve: [
        // Copied from https://github.com/algolia/docsearch/blob/ce0c865cd8767e961ce3088b3155fc982d4c2e2e/packages/docsearch-react/src/DocSearchModal.tsx#L231
        'hierarchy.lvl0', 'hierarchy.lvl1', 'hierarchy.lvl2', 'hierarchy.lvl3', 'hierarchy.lvl4', 'hierarchy.lvl5', 'content', 'type', 'url',
        // Extra
        'productId', 'productCategoryId'],
        analyticsTags: [facetFilterLanguage, "product:".concat(pageContext.productId)],
        hitsPerPage: 40
      },
      placeholder: "".concat(t('algoliaSearch')),
      transformItems: function transformItems(items) {
        return items.map(function (item) {
          // `url` contains the domain
          // but we want to link to the current domain e.g. deploy-preview-1--material-ui.netlify.app
          var parseUrl = document.createElement('a');
          parseUrl.href = item.url;
          var _pathnameToLanguage = pathnameToLanguage("".concat(parseUrl.pathname).concat(parseUrl.hash)),
            canonicalAs = _pathnameToLanguage.canonicalAs,
            canonicalPathname = _pathnameToLanguage.canonicalPathname;
          return _extends({}, item, {
            pathname: canonicalPathname,
            as: canonicalAs,
            userLanguage: userLanguage
          });
        });
      },
      hitComponent: DocSearchHit,
      initialScrollY: true ? window.scrollY : undefined,
      onClose: onClose,
      navigator: keyboardNavigator
    }), document.body), /*#__PURE__*/_jsx(GlobalStyles, {
      styles: function styles(theme) {
        return {
          html: {
            ':root': {
              '--docsearch-primary-color': (theme.vars || theme).palette.primary[600],
              '--docsearch-text-color': (theme.vars || theme).palette.text.primary,
              '--docsearch-muted-color': (theme.vars || theme).palette.grey[600],
              '--docsearch-searchbox-shadow': 0,
              '--docsearch-hit-shadow': 0,
              '--docsearch-footer-shadow': 0,
              '--docsearch-spacing': theme.spacing(1.5),
              '--docsearch-hit-active-color': (theme.vars || theme).palette.primary[600],
              '--docsearch-logo-color': (theme.vars || theme).palette.grey[600],
              '--docsearch-searchbox-focus-background': 'unset',
              '--docsearch-footer-background': 'unset',
              '--docsearch-modal-background': (theme.vars || theme).palette.background.paper
            }
          },
          body: {
            '.DocSearch-Container': {
              transition: "opacity ".concat(FADE_DURATION, "ms"),
              opacity: 0,
              zIndex: theme.zIndex.tooltip + 100,
              backgroundColor: alpha(theme.palette.grey[700], 0.5),
              backdropFilter: 'blur(2px)'
            },
            '& .DocSearch-StartScreen': {
              display: 'none'
            },
            '& .DocSearch-NewStartScreen': {
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: theme.spacing(2),
              paddingBottom: theme.spacing(2)
            },
            '& .DocSearch-NewStartScreenCategory': {
              display: 'flex',
              flexDirection: 'column'
            },
            '& .DocSearch-NewStartScreenTitle': {
              display: 'flex',
              alignItems: 'center',
              padding: theme.spacing(2, 3, 1.5, 2),
              fontSize: theme.typography.pxToRem(11),
              fontWeight: theme.typography.fontWeightBold,
              textTransform: 'uppercase',
              letterSpacing: '.1rem',
              color: (theme.vars || theme).palette.text.tertiary
            },
            '& .DocSearch-NewStartScreenTitleIcon': {
              fontSize: theme.typography.pxToRem(18),
              color: (theme.vars || theme).palette.primary[500],
              marginRight: theme.spacing(1.5),
              opacity: 0.6,
              // Redefine SvgIcon-root style as ReactDOMServer.renderToStaticMarkup doesn't
              // Generate the CSS.
              // TODO v6: This hack should no longer be needed with static CSS rendering.
              userSelect: 'none',
              width: '1em',
              height: '1em',
              display: 'inline-block',
              flexShrink: 0,
              fill: 'currentColor'
            },
            '& .DocSearch-NewStartScreenItem': {
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              width: '100%',
              height: '42px',
              color: (theme.vars || theme).palette.primary[600],
              fontSize: theme.typography.pxToRem(14),
              fontWeight: theme.typography.fontWeightMedium,
              padding: theme.spacing(0.25, 0),
              paddingLeft: theme.spacing(2),
              border: '1px solid transparent',
              borderRadius: theme.shape.borderRadius,
              backgroundColor: alpha(theme.palette.grey[50], 0.4),
              borderColor: alpha(theme.palette.grey[100], 0.5),
              marginBottom: theme.spacing(1),
              '&:hover, &:focus': {
                backgroundColor: (theme.vars || theme).palette.primary[50],
                borderColor: (theme.vars || theme).palette.primary[300]
              },
              '&:focus-visible': {
                outline: '3px solid',
                outlineColor: (theme.vars || theme).palette.primary[200],
                outlineOffset: 0
              }
            },
            '& .DocSearch-Modal': {
              // docsearch.css: <= 750px will be full screen modal
              maxWidth: '640px',
              boxShadow: "0px 4px 16px ".concat(alpha(theme.palette.common.black, 0.2)),
              borderRadius: theme.shape.borderRadius,
              border: '1px solid',
              borderColor: (theme.vars || theme).palette.grey[300]
            },
            '& .DocSearch-SearchBar': {
              borderBottom: '1px solid',
              borderColor: (theme.vars || theme).palette.grey[200],
              padding: theme.spacing(0.5, 1)
            },
            '& .DocSearch-Form': {
              '& .DocSearch-Reset': {
                display: 'none'
              },
              '& .DocSearch-Input': {
                paddingLeft: theme.spacing(2),
                fontSize: theme.typography.pxToRem(16),
                fontWeight: theme.typography.fontWeightMedium
              },
              '& .DocSearch-Search-Icon': {
                width: '18px',
                height: '18px'
              },
              '& .DocSearch-VisuallyHiddenForAccessibility': {
                width: 0,
                visibility: 'hidden'
              }
            },
            '& .DocSearch-Cancel': {
              display: 'block',
              alignSelf: 'center',
              cursor: 'pointer',
              height: '1.5rem',
              marginRight: theme.spacing(1),
              padding: theme.spacing(0.3, 0.8, 0.6, 0.8),
              fontSize: 0,
              borderRadius: 6,
              backgroundColor: (theme.vars || theme).palette.grey[50],
              border: '1px solid',
              borderColor: (theme.vars || theme).palette.grey[200],
              '&::before': {
                content: '"esc"',
                fontFamily: theme.typography.fontFamilyCode,
                fontSize: theme.typography.pxToRem(12),
                fontWeight: theme.typography.fontWeightBold,
                color: (theme.vars || theme).palette.text.secondary
              }
            },
            '& .DocSearch-Dropdown': {
              minHeight: 384,
              // = StartScreen height, to prevent layout shift when first char
              '&::-webkit-scrollbar-thumb': {
                borderColor: (theme.vars || theme).palette.background.paper,
                backgroundColor: (theme.vars || theme).palette.grey[500]
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: (theme.vars || theme).palette.background.paper
              },
              '* ul': {
                marginTop: theme.spacing(1)
              }
            },
            '& .DocSearch-Dropdown-Container': {
              '& .DocSearch-Hits:first-of-type': {
                '& .DocSearch-Hit-source': {
                  paddingTop: theme.spacing(2.5),
                  paddingBottom: theme.spacing(0.5)
                }
              }
            },
            '& .DocSearch-Hit-source': {
              top: 'initial',
              padding: theme.spacing(1.5, 3, 1.5, 3),
              background: 'transparent',
              fontSize: theme.typography.pxToRem(11),
              fontWeight: theme.typography.fontWeightBold,
              textTransform: 'uppercase',
              lineHeight: 1,
              letterSpacing: '.1rem',
              color: (theme.vars || theme).palette.text.tertiary
            },
            '& .DocSearch-Hit': {
              paddingBottom: 8,
              '&:not(:first-of-type)': {
                marginTop: -1
              },
              '& .DocSearch-Hit-Container': {
                height: '52px'
              }
            },
            '& .DocSearch-Hit a': {
              padding: theme.spacing(0.25, 0),
              paddingLeft: theme.spacing(2),
              border: '1px solid transparent',
              borderRadius: theme.shape.borderRadius,
              backgroundColor: alpha(theme.palette.grey[50], 0.4),
              borderColor: alpha(theme.palette.grey[100], 0.5),
              '&:focus-visible': {
                outline: '3px solid',
                outlineColor: (theme.vars || theme).palette.primary[200],
                outlineOffset: 0,
                backgroundColor: (theme.vars || theme).palette.primary[50],
                borderColor: (theme.vars || theme).palette.primary[300]
              }
            },
            '& .DocSearch-Hit-content-wrapper': {
              paddingLeft: theme.spacing(1)
            },
            '& .DocSearch-Hit-title': {
              fontSize: theme.typography.pxToRem(14),
              fontWeight: theme.typography.fontWeightMedium,
              color: (theme.vars || theme).palette.text.primary
            },
            '& .DocSearch-Hit-path': {
              fontSize: theme.typography.pxToRem(12),
              color: (theme.vars || theme).palette.text.secondary
            },
            '& .DocSearch-Hit-icon': {
              '> svg': {
                height: '16px',
                width: '16px',
                margin: 0
              }
            },
            '& .DocSearch-Hit-Select-Icon': {
              height: '14px',
              width: '14px'
            },
            '& .DocSearch-Hit[aria-selected="true"] a': {
              backgroundColor: (theme.vars || theme).palette.primary[50],
              borderColor: (theme.vars || theme).palette.primary[300]
            },
            '& .DocSearch-Hit-action, & .DocSearch-Hits mark': {
              color: (theme.vars || theme).palette.primary[500],
              '& .DocSearch-Hit-action-button': {
                display: 'flex',
                width: '24px',
                borderRadius: '6px',
                border: '1px solid transparent',
                '> svg': {
                  margin: 0
                },
                '&:hover': {
                  backgroundColor: (theme.vars || theme).palette.primary[100],
                  borderColor: (theme.vars || theme).palette.primary[300]
                }
              }
            },
            '& .DocSearch-Footer': {
              borderTop: '1px solid',
              borderColor: (theme.vars || theme).palette.grey[200],
              '& .DocSearch-Commands': {
                display: 'none'
              }
            }
          }
        };
      }
    }), /*#__PURE__*/_jsx(GlobalStyles, {
      styles: function styles(theme) {
        return [_defineProperty({}, theme.vars ? '[data-mui-color-scheme="dark"]:root' : '.mode-dark', {
          '--docsearch-primary-color': (theme.vars || theme).palette.primaryDark[300],
          '--docsearch-hit-active-color': (theme.vars || theme).palette.primary[300]
        }), _defineProperty({}, theme.vars ? '[data-mui-color-scheme="dark"] body' : '.mode-dark', {
          '.DocSearch-Container': {
            backgroundColor: alpha(theme.palette.grey[900], 0.6)
          },
          '& .DocSearch-NewStartScreenTitleIcon': {
            color: (theme.vars || theme).palette.primary[300]
          },
          '& .DocSearch-NewStartScreenItem': {
            color: (theme.vars || theme).palette.primary[300],
            backgroundColor: alpha(theme.palette.primaryDark[800], 0.5),
            borderColor: alpha(theme.palette.primaryDark[700], 0.8),
            '&:hover, &:focus': {
              backgroundColor: alpha(theme.palette.primary[900], 0.4),
              borderColor: alpha(theme.palette.primary[700], 0.6)
            },
            '&:focus-visible': {
              outlineColor: (theme.vars || theme).palette.primary[700]
            }
          },
          '& .DocSearch-Modal': {
            backgroundColor: (theme.vars || theme).palette.primaryDark[900],
            boxShadow: "0px 4px 16px ".concat(alpha(theme.palette.common.black, 0.8)),
            border: '1px solid',
            borderColor: (theme.vars || theme).palette.primaryDark[700]
          },
          '& .DocSearch-SearchBar': {
            borderColor: (theme.vars || theme).palette.primaryDark[700]
          },
          '& .DocSearch-Cancel': {
            backgroundColor: (theme.vars || theme).palette.primaryDark[800],
            borderColor: (theme.vars || theme).palette.primaryDark[600]
          },
          '& .DocSearch-Dropdown': {
            '&::-webkit-scrollbar-thumb': {
              borderColor: (theme.vars || theme).palette.primaryDark[900],
              backgroundColor: (theme.vars || theme).palette.primaryDark[100]
            }
          },
          '& .DocSearch-Hit a': {
            backgroundColor: alpha(theme.palette.primaryDark[800], 0.5),
            borderColor: alpha(theme.palette.primaryDark[700], 0.8),
            '&:focus-visible': {
              outlineColor: alpha(theme.palette.primary[400], 0.5),
              backgroundColor: alpha(theme.palette.primary[900], 0.4),
              borderColor: alpha(theme.palette.primary[700], 0.6)
            }
          },
          '& .DocSearch-Hit[aria-selected="true"] a': {
            color: (theme.vars || theme).palette.primary[300],
            backgroundColor: alpha(theme.palette.primary[900], 0.4),
            borderColor: alpha(theme.palette.primary[700], 0.6)
          },
          '& .DocSearch-Hit-action, & .DocSearch-Hits mark': {
            color: (theme.vars || theme).palette.primary[400],
            '& .DocSearch-Hit-action-button': {
              '&:hover': {
                backgroundColor: alpha(theme.palette.primary[900], 0.8),
                borderColor: alpha(theme.palette.primary[700], 0.8)
              }
            }
          },
          '& .DocSearch-Footer': {
            borderColor: (theme.vars || theme).palette.primaryDark[700]
          }
        })];
      }
    })]
  });
}